export const convertToPercent = (value: number) => value * 100 || 0;
